import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const hitSentenceResolver: FieldResolver = (metadata: Metadata) =>
  ({ hitSentence: metadata.getHitSentence() } as StreamData)

export default hitSentenceResolver
